import { createEntityAdapter, createReducer } from '@reduxjs/toolkit';
import { CommitModel } from '../../models/commitModel';
import { CommitsStateModel } from './commitsStateModel';
import {
  commitsFetchOneFailureAction
, commitsFetchOneRequestAction
, commitsFetchOneSuccessAction
} from './commitsActions';

export const commitsAdapter = createEntityAdapter<CommitModel>();

const initialState: CommitsStateModel = commitsAdapter.getInitialState({
  loading: false,
  errors: [],
});

export const commitsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(commitsFetchOneRequestAction, (state) => {
      state.loading = true;
      state.errors = [];
    })
    .addCase(commitsFetchOneSuccessAction, (state, action) => {
      state.loading = false;
      commitsAdapter.addOne(state, action.payload);
    })
    .addCase(commitsFetchOneFailureAction, (state, action) => {
      state.loading = false;
      state.errors = [...state.errors, action.payload];
    });
});
